import React, { Dispatch, SetStateAction } from 'react'

import { CsvImportButton } from '../../../ui/CsvImportButton'

interface CsvTagsImportProps {
  onImport: Dispatch<SetStateAction<string>>
}

export const CsvTagsImport: React.FC<CsvTagsImportProps> = ({ onImport }) => {
  return (
    <CsvImportButton
      mappings={['tags']}
      handleImport={records => {
        const newTags = Array.from(new Set(records.map(record => record.tags))).filter(Boolean)
        onImport(prevTags => (prevTags ? `${prevTags},${[...newTags].join(',')}` : newTags.join(',')))
      }}
    />
  )
}
